import React from 'react';
import Loadable from 'react-loadable';
import qs from 'qs';

import LoadableLoading from 'components/LoadableLoading';
import { IProps } from './interfaces';

export const path = '/chrona/tracker/:guid';

/** Экран дома; дата и сотрудник с открытой панелью отметки - необязательно. */
export const getPath = (guid: string, date?: string, user?: string) => {
  const search = qs.stringify({ date, user }, { skipNulls: true });
  const query = search ? `?${search}` : '';
  return `/chrona/tracker/${encodeURIComponent(guid)}${query}`;
};

// На уровне модуля, а не в компоненте: иначе каждая смена даты или открытие панели в адресе
// пересоздавали бы страницу - со сбросом вкладки и повторной загрузкой.
const LoadableMap = Loadable.Map({
  loader: {
    page: () => import('./page'),
    i18n: () => import('./ru.json'),
  },
  loading: LoadableLoading,
  render(loaded: any, loadedProps: {}) {
    const Page = loaded.page.default;

    return <Page i18n={loaded.i18n} {...loadedProps} />;
  },
});

const PageChronaVisitHouse: React.FC<IProps> = (props) => <LoadableMap {...props} />;

export default PageChronaVisitHouse;
